import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import BenefitsWholeYouSection from '../Components/Benefits/BenefitsWholeYouSection'
import FinancialWellbeingSection from '../Components/Benefits/FinancialWellbeingSection'
import YourTimeOffSection from '../Components/Benefits/YourTimeOffSection'
import MentalWellbeingSection from '../Components/Benefits/MentalWellbeingSection'
import YourFamilyWellbeingSection from '../Components/Benefits/YourFamilyWellbeingSection'
import PhysicalWellbeingSection from '../Components/Benefits/PhysicalWellbeingSection'
import YourSection from '../Components/Benefits/YourSection'
import { Helmet } from "react-helmet-async";

function Benefits() {
    return (
        <div>
            <Helmet>
    <title>
        Employee Benefits at Mobikode | Wellbeing & Workplace Benefits
    </title>

    <meta
        name="description"
        content="Explore employee benefits at Mobikode designed to support financial wellbeing, mental and physical health, family wellbeing, time off, and overall employee growth."
    />

    <meta
        name="keywords"
        content="Mobikode Employee Benefits, Employee Benefits, Employee Wellbeing, Workplace Benefits, Employee Wellness Programs, Financial Wellbeing, Mental Wellbeing, Physical Wellbeing, Family Benefits, Paid Time Off, Employee Benefits at Mobikode, IT Company Benefits, Employee Support Programs"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/benefits"
    />

    <meta
        property="og:title"
        content="Employee Benefits at Mobikode | Wellbeing & Workplace Benefits"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's employee benefits focused on financial, mental, physical, and family wellbeing, along with time off and support for a balanced work life."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/benefits"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/benefits/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Employee Benefits at Mobikode | Wellbeing & Workplace Benefits"
    />

    <meta
        name="twitter:description"
        content="Learn about Mobikode's employee benefits supporting financial wellbeing, time off, mental health, physical health, family wellbeing, and overall employee experience."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/benefits/bg1.png"
    />
</Helmet>
            <WhoHero
                title="Benefits"
                text="Technology. Transformation. Trust."
                imgData="/assets/benefits/bg1.png"
            />
            <BenefitsWholeYouSection />
            <FinancialWellbeingSection />
            <YourTimeOffSection />
            <MentalWellbeingSection />
            <YourFamilyWellbeingSection />
            <PhysicalWellbeingSection />
            <YourSection />
        </div>
    )
}

export default Benefits
